import React from 'react'

function Audit() {
  return (
    <div>
      Audit Page
    </div>
  )
}

export default Audit
